import { render, staticRenderFns } from "./PersonaUpdate.vue?vue&type=template&id=09edaac1&scoped=true"
import script from "./PersonaUpdate.vue?vue&type=script&lang=js"
export * from "./PersonaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09edaac1",
  null
  
)

export default component.exports